import { useMutation } from '@tanstack/react-query';

import { EmancipateChildPromoResponse, emancipateChildPromo } from '~/services/PromoService';

export function useEmancipateChildPromo() {
  return useMutation<EmancipateChildPromoResponse, Error, string>({
    mutationFn: async (idPromoCode) => emancipateChildPromo(idPromoCode),
  });
}
